if(BSS_B2B) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

  //fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

 BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  
//fix change variant product page
  if(window.location.pathname.includes("/products/")) {
    setTimeout(() =>{
      const targetPrice = document.querySelector(".product__info-container .no-js-hidden[bss-b2b-product-id]");
      if (targetPrice) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
            BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
        });
        mutationObserver.observe(targetPrice, { attributes: true });
      }
    }, 1000)
  }
  
//fix quickview
  if (!window.location.pathname.includes("/product/")) {
    setTimeout(() => {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        for (const record of recordList) {
          const condition = record.target?.classList?.contains( "shopify-payment-button");
          if (condition) {
            const variant = $(".product-form input[name='id']").val();
            BSS_B2B.cp.changeProductPrice(
              JSON.parse($("#bss-b2b-store-data").html()),
              ".quick-view__right .no-js-hidden [bss-b2b-variant-price]",
              false,
              true,
              variant
            );
            const targetPrice = document.querySelector( ".product__info-container .no-js-hidden[bss-b2b-product-id]");
            if (targetPrice) {
              const mutationObserver = new MutationObserver(
                (recordList, observe) => {
                  const variantId = $(".product-form input[name='id']").val();
                  BSS_B2B.cp.changeProductPrice(
                    JSON.parse($("#bss-b2b-store-data").html()),
                    ".quick-view__right .no-js-hidden [bss-b2b-variant-price]",
                    false,
                    true,
                    variantId
                  );
                }
              );
              mutationObserver.observe(targetPrice, { attributes: true });
            }
          }
        }
      });
      mutationObserver.observe(document, { childList: true, subtree: true });
    }, 1000);
  }

//fix mini-cart
  setTimeout(() =>{
    const targetMiniCart = document.querySelector(".cart-drawer-container");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
          setTimeout(() =>{
            BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
          }, 1000)
      });
      mutationObserver.observe(targetMiniCart, { attributes: true });
    }
  }, 500)
}
  